import { api } from '../utils/api';
import type { Order } from '../types/@types/order';

export interface OrderHistoryParams {
  from?: string;
  to?: string;
  status?: string;
  payment_status?: string;
  fulfillment_type?: string;
  search?: string;
  page?: number;
  per_page?: number;
}

export interface OrderHistoryResponse {
  data: Order[];
  total: number;
  per_page: number;
  current_page: number;
  last_page: number;
}

export async function getOrderHistory(
  params: OrderHistoryParams = {},
): Promise<OrderHistoryResponse> {
  const { data } = await api.get<OrderHistoryResponse>('/orders', { params });
  return data;
}
